//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import mixin from './mixin'
export default {
    mixins: [
        mixin
    ]
}
